<template>
  <section class="flex column">
    <div class="box w100">
      <div class="box-title">
        <b>Perfil do Comprador</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div>
            Email: {{ detail.sale && detail.sale.email }}
          </div>
          <div v-if="detail.sale.phone" class="margin-top-s">
            Telefone: {{ detail.sale.phone }}
          </div>
          <div v-else> Telefone: - </div>
        </div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Compras</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div v-if="detail.sales && detail.sales.length > 0" class="flex column">
          <div class="flex w100">
            <div class="flex-2">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Valor</b>
            </div>
            <div class="flex-1">
              <b>Plataforma</b>
            </div>
            <div class="flex-1">
              <b>Status</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.sales" :key="key" class="flex w100 margin-top-s">
            <div class="flex-2">
              {{ s.order_id }}
            </div>
            <div class="flex-1">
              {{ s.price | money }}
            </div>
            <div class="flex-1">
              {{ s.platform }}
            </div>
            <div class="flex-1">
              {{ s.status }}
            </div>
            <div class="flex-1">
              {{ s.created_at | date }}
            </div>
          </div>
        </div>
        <div v-else> Não encontramos compras...</div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Produtos</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div v-if="detail.products && detail.products.length > 0" class="flex column">
          <div class="flex w100">
            <div class="flex-2">
              <b>Nome</b>
            </div>
          </div>
          <div v-for="(p, key) in detail.products" :key="key" class="flex w100 margin-top-s">
            <div class="flex-2">
              {{ p }}
            </div>
          </div>
        </div>
        <div v-else> Não encontramos produtos...</div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Páginas Visitadas</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div class="flex w100">
            <div class="flex-1">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
            <div class="flex-2">
              <b>Url</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.trackers" :key="key" class="flex w100 column jorney-style">
            <div class="flex w100 margin-top-s middle">
              <div class="flex-1 w100">
                {{ s.id | number  }}
              </div>
              <div class="flex-1">
                {{ s.created_at | date }}
              </div>
              <div v-if="!s.url.includes('no-page-tracker')" class="flex-2">
                <b>{{ s.url }}</b>
              </div>
              <div v-else class="flex-2"> - </div>
            </div>
            <div class="flex w100 margin-top-s column">
              <div class="flex-1 flex column">
                <span class="tag" v-if="s.utm_campaign">utm_campaign: {{ s.utm_campaign }}</span>
                <span class="tag" v-if="s.utm_medium">utm_medium: {{ s.utm_medium }}</span>
                <span class="tag" v-if="s.utm_source">utm_source: {{ s.utm_source }}</span>
                <span class="tag" v-if="s.utm_content">utm_content: {{ s.utm_content }}</span>
                <span class="tag" v-if="s.utm_term && !s.utm_term.includes('LUCREIHOJE')">utm_term: {{ s.utm_term }}</span>
                <span class="tag" v-if="s.src && !s.src.includes('LUCREIHOJE')">src: {{ s.src }}</span>
                <span class="tag" v-if="s.sck">sck: {{ s.sck }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>
  </section>
</template>

<script>

import { 
  getSale
} from "@/services/jorney-detail.js";

export default {
  name: "sale-detail",
  components: {
  },
  props: ['sale_id'],
  data() {
    return {
      loading: true,
      detail: {
        sale: {},
        sales: [],
        products: [],
        trackers: [],
      },
    };
  },
  mounted() {
    this.getSale()
  },
  watch: {
  },
  methods: {
    getSale() {
      this.loading = true
      getSale(this.sale_id)
      .then((result) => {
        this.detail = result
      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu algum problema'
        })
      })
      .finally(() => {
        this.loading = false
      })
    }

  }

};
</script>

<style lang="scss" scoped>
.grid-flex .box + .box, .flex .box + .box {
  margin-left: 0px;
}
.jorney-style {
  padding: 8px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  margin-top: 4px;
}
.tag {
  background: var(--secondary);
  padding: 2px 4px;
  color: #fff;
  border-radius: 5px;
  font-weight: 400;
  margin-top: 4px;
  display: inline-block;
}
</style>
